import React from 'react';

const PromoContext = React.createContext({});
export default PromoContext;
